import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { GetBusinessPartnersResponse } from '../models/business-partner-backoffice.model';

@Injectable({
  providedIn: 'root',
})
export class BusinessPartnerBackofficeService {
  protected backofficeBaseUrl =
    this.env.API_BASE_URL + '/service/business-partner-backoffice/secure/';

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector)
    private readonly env: Environment,
  ) {}

  getBusinessPartners(
    keyword: string,
    currentPage: number,
    currentPageSize: number,
    sortDirection: SortDirection,
  ): Observable<GetBusinessPartnersResponse> {
    if (keyword) {
      keyword = keyword.trim();
    }

    let sort = 0;
    if (sortDirection === 'desc') {
      sort = 1;
    }
    return this.http.get<GetBusinessPartnersResponse>(
      `${this.backofficeBaseUrl}search/businesspartners?keyword=${keyword}&pageNumber=${currentPage}&pageSize=${currentPageSize}&sortDirection=${sort}`,
    );
  }
}
